import { PAGE_TYPES } from '../enums/page-types';

export function getMedia({ checkout = {}, product = {} }) {
  return checkout.type === PAGE_TYPES.FORM || checkout.type === PAGE_TYPES.EVENT
    ? checkout.images
    : product.media;
}
